import React from "react";
import HeaderTitle from "./HeaderTitle";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Header = ({ title, desc, Back = false, children }) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-start flex-wrap font-quicksand max850:hidden gap-3 mb-1">
      {Back ? (
        <div className="flex items-start gap-x-2.5 min-w-0">
          <button
            type="button"
            aria-label="Go back"
            className="mt-1 inline-flex h-9 w-9 items-center justify-center rounded-xl border border-line bg-card text-main shadow-soft hover:bg-brandSoft hover:border-main/30 transition-colors"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft size={18} />
          </button>
          <HeaderTitle title={title} description={desc} />
        </div>
      ) : (
        <HeaderTitle title={title} description={desc} />
      )}
      {children ? (
        <div className="flex items-center justify-end gap-2 flex-wrap gap-y-2 pb-1 max440:w-full max440:justify-start">
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default Header;
